import listeningLogoPng from '@listening/assets/imgs/listeningLogoLong.png';
import logoBigDark from '@listening/assets/imgs/logo/listeningLogoLongDark.svg';
import { useTheme } from '@/components/shared-ui/theme-provider';

export function useBigLogoSrc() {
  const { isDark } = useTheme();
  return isDark ? logoBigDark : listeningLogoPng;
}
